import { render, staticRenderFns } from "./BugIcon.vue?vue&type=template&id=548b5f2c"
import script from "./BugIcon.vue?vue&type=script&lang=js"
export * from "./BugIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports